<template>
  <el-form-item :label="label" v-bind="$attrs">
    <el-radio-group :value="value" class="a-radio-group" @input="onInput">
      <el-radio v-for="(item, index) in radioOptions"
                :key="index"
                :label="item.value">{{item.label}}
      </el-radio>
    </el-radio-group>
  </el-form-item>
</template>

<script>
  export default {
    name: 'base-radio',
    inheritAttrs: false,
    props: {
      value: String,
      label: String,
      radioOptions: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      onInput(value) {
        this.$emit('input', value)
      }
    }
  }
</script>
